<template>
  <div class="page">
    <section
      class="hero-section-parallax-overlay parallax-container section"
      :data-parallax-img="
        getContent(
          pageContent?.currentLocaleData,
          pageContent?.defaultLocaleData,
          'heroSection.image'
        )
      "
    >
      <div class="parallax-content section hero-section context-dark">
        <div class="container">
          <h2 v-html="heroTitleContent" data-aos="fade-up" />

          <h2 data-aos="fade-up" data-aos-delay="400">
            {{
              getContent(
                pageContent?.currentLocaleData,
                pageContent?.defaultLocaleData,
                "heroSection.subtitle"
              )
            }}
          </h2>

          <hr
            class="hero-section-divider divider"
            data-aos="fade-up"
            data-aos-delay="800"
          />

          <div data-aos="fade-up" data-aos-delay="1200">
            <button
              class="hero-section__request-btn button"
              type="button"
              @click="openModal('reservation')"
            >
              {{
                getContent(
                  pageContent?.currentLocaleData,
                  pageContent?.defaultLocaleData,
                  "heroSection.requestBtnLabel"
                )
              }}
            </button>
          </div>
        </div>
        <!-- <div
          class="hero-section__scroll-arrow hero-section__scroll-arrow--first"
        />
        <div
          class="hero-section__scroll-arrow hero-section__scroll-arrow--second"
        /> -->
      </div>
    </section>
  </div>
</template>

<script setup>
const { getContent, replaceContent } = useProjectMethods();
const { openModal } = useModalStore();

const contentParams = {
  contentKey: "homePageContent",
  contentRoute: ["pages", "home"],
  isPage: true,
};
const { getContentData } = useContentLogic(contentParams);
const { data: pageContent } = await useLazyAsyncData(getContentData);

const heroTitleContent = computed(() => {
  return replaceContent(
    getContent(
      pageContent.value?.currentLocaleData,
      pageContent.value?.defaultLocaleData,
      "heroSection.title"
    ),
    "*"
  );
});
</script>

<style lang="scss" scoped>
.hero-section-parallax-overlay {
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--home-page-parallax-overlay-bg);
  }
}

.hero-section {
  --section-padding: 60px;

  display: flex;
  justify-content: center;
  align-items: center;
  min-height: max(91vh, 550px);
  padding-top: var(--section-padding);
  padding-bottom: var(--section-padding);
  text-align: center;

  @media (min-width: 1200px) and (min-height: 857px) {
    padding-bottom: 185px;
  }

  h2 {
    margin-left: auto;
    margin-right: auto;
    font-size: 40px;
    text-transform: uppercase;

    @media (min-width: 576px) {
      font-size: 52px;
      max-width: 900px;
    }
  }

  h4 {
    margin-left: auto;
    margin-right: auto;
    font-size: 18px;
    font-weight: 400;
    text-transform: uppercase;

    @media (min-width: 576px) {
      font-size: 22px;
    }
  }
}

.hero-section-divider {
  height: 6px;
  width: 200px;
  margin-left: auto;
  margin-right: auto;
  border-color: var(--secondary-col);

  &::after {
    width: 100%;
    height: 100%;
    background-color: var(--secondary-col);
  }
}

.hero-section__request-btn {
  margin-top: 32px;
  position: relative;
  transform: scale(1.2);
  overflow: visible;

  color: #ffffff;
  background-color: var(--error-col);
  border-color: var(--error-col);

  &:is(:hover, :active, :focus) {
    color: #ffffff;
    background-color: var(--error-col);
    border-color: var(--error-col);
    transform: scale(1.3);
  }
}

.hero-section__request-btn::after {
  content: "";
  position: absolute;
  z-index: -1;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  display: block;
  width: 100%;
  height: 100%;
  background: var(--error-col);
  animation: pulse-border 1500ms ease-out infinite;
}

@keyframes pulse-border {
  0% {
    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
    opacity: 1;
  }
  100% {
    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1.5);
    opacity: 0;
  }
}

// $ani-speed: 2.4s;
// $ani-delay: 1.2s;

// .hero-section__scroll-arrow {
//   opacity: 0;
//   position: absolute;
//   width: 30px;
//   left: 50%;
//   bottom: 12%;
//   transform-origin: 50% 50%;
//   transform: translate(-50%, -50%);

//   &::before,
//   &::after {
//     background: #ffffff;
//     content: "";
//     display: block;
//     height: 3px;
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 30px;
//   }

//   &::before {
//     transform: rotate(45deg) translateX(-20%);
//     transform-origin: top left;
//   }

//   &::after {
//     transform: rotate(-45deg) translateX(20%);
//     transform-origin: top right;
//   }
// }

// .hero-section__scroll-arrow--first {
//   animation: arrow-movement $ani-speed ease-out infinite;
// }
// .hero-section__scroll-arrow--second {
//   animation: arrow-movement $ani-speed $ani-delay ease-out infinite;
// }

// @keyframes arrow-movement {
//   0% {
//     opacity: 0;
//     bottom: 16%;
//   }
//   70% {
//     opacity: 1;
//   }
//   100% {
//     opacity: 0;
//   }
// }
</style>
